import axios from "axios";

const API = axios.create({
baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/organizations/superadmin`,
});

// ➕ Create Organization
export async function createOrganization(payload) {
  try {
    const res = await API.post("/create", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}


// 📖 Get Organization by ID
export async function getOrganization() {
  try {
    const res = await API.get(`/get`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✏️ Update Organization
export async function updateOrganization(orgId, payload) {
  try {
    const res = await API.put(`/update/${orgId}`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 🗑️ Delete Organization
export async function deleteOrganization(orgId) {
  try {
    const res = await API.delete(`/delete/${orgId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}
